export const MESSAGE_CHARACTER_LIMIT = 256;
